import cx from 'classnames';
import styles from './index.module.css';
/**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11} top
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11} right
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11} bottom
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11} left
 */

/**
 * @param top {top}
 * @returns - [className]
 *
 * @example
 * const [topClassName] = getTop(3);
 */

export var getTop = function getTop(top) {
  var _cx;

  var classNames = cx((_cx = {}, _cx[styles["top" + top]] = typeof top === 'number', _cx));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classNames];
};
/**
 * @param right {right}
 * @returns - [className]
 *
 * @example
 * const [rightClassName] = getRight(3);
 */

export var getRight = function getRight(right) {
  var _cx2;

  var classNames = cx((_cx2 = {}, _cx2[styles["right" + right]] = typeof right === 'number', _cx2));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classNames];
};
/**
 * @param bottom {bottom}
 * @returns - [className]
 *
 * @example
 * const [bottomClassName] = getBottom(3);
 */

export var getBottom = function getBottom(bottom) {
  var _cx3;

  var classNames = cx((_cx3 = {}, _cx3[styles["bottom" + bottom]] = typeof bottom === 'number', _cx3));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classNames];
};
/**
 * @param left {left}
 * @returns - [className]
 *
 * @example
 * const [leftClassName] = getLeft(3);
 */

export var getLeft = function getLeft(left) {
  var _cx4;

  var classNames = cx((_cx4 = {}, _cx4[styles["left" + left]] = typeof left === 'number', _cx4));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classNames];
};